import { useLocation, useNavigate } from "react-router-dom";

export const usePathname = () => useLocation().pathname;

export const useRouter = () => {
  const navigate = useNavigate();

  return {
    push: (href: string, options?: { scroll?: boolean }) => {
      navigate(href);
      if (options?.scroll !== false) window.scrollTo({ top: 0, left: 0 });
    },
    replace: (href: string) => navigate(href, { replace: true }),
  };
};
